module.exports = __webpack_public_path__ + "img/circle_red_2_right.fe6aec7a.png";